<script lang="ts" setup>
import { useUserStore } from '~~/stores/UserStore'

const toast = useToast()
const userStore = useUserStore()

const form = reactive({
  name: userStore.user?.name || '',
  phone: '',
  email: userStore.user?.email || '',
  message: ''
})
const loading = ref(false)

async function submit() {
  if (form.name === '' || form.email === '' || form.message === '') {
    toast.add({ title: 'Error', description: 'Please fill in all required fields.', color: 'error' })
    return
  }
  loading.value = true
  try {
    await $fetch('/api/submit-issue', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    })
    toast.add({ title: 'Success', description: 'Your issue has been submitted.', color: 'success' })
  } catch (error) {
    console.error('Error submitting issue:', error)
    toast.add({ title: 'Error', description: 'An unexpected error occurred.', color: 'error' })
  }
  finally {
    form.name = userStore.user?.name || '',
    form.phone = ''
    form.email = userStore.user?.email || '',
    form.message = ''
  }
  loading.value = false
}
</script>

<template>
  <UModal title="Submit an Issue">
    <UTooltip text="Report an issue">
      <UButton icon="i-heroicons-question-mark-circle-16-solid" color="warning" />
    </UTooltip>
    <template #body>
      <div class="flex flex-col gap-4">
        <form @submit.prevent="submit">
          <div class="flex flex-col gap-4 mb-8">
            <UFormField required label="Name">
              <UInput v-model="form.name" placeholder="John Smith" disabled class="w-full" />
            </UFormField>
            <UFormField label="Phone">
              <UInput v-model="form.phone" placeholder="281-330-8004" class="w-full" />
            </UFormField>
            <UFormField required label="Email">
              <UInput v-model="form.email" disabled placeholder="you@example.com" class="w-full" />
            </UFormField>
            <UFormField required label="Message">
              <UTextarea v-model="form.message" placeholder="Your message here..." class="w-full" />
            </UFormField>
            
          </div>
          <div class="flex flex-row justify-end">
            <UButton type="submit" trailing-icon="i-heroicons-paper-airplane-solid">
              Submit
            </UButton>
          </div>
        </form>

      </div>
    </template>
  </UModal>

</template>